import { BLOCKS } from "../world/blocks";
import { toolInfo } from "../world/items";

/**
 * Pure mining rules shared by the game loop and tests.
 *
 * A block's `tool` names the class that mines it faster. `minTier` is the tool
 * tier needed for the block to drop anything; a player can still break a
 * gated block bare-handed, it just yields nothing.
 */

const TIER_NAMES: readonly string[] = ["Hand", "Wooden", "Stone", "Iron", "Diamond"];

/** Mining-speed multiplier for `heldId` against `blockId` (1 = bare hand). */
export function miningSpeed(blockId: number, heldId: number): number {
  const def = BLOCKS[blockId];
  const tool = toolInfo(heldId);
  if (!tool) return 1;
  // Minecraft 1.8.8 ItemSword: swords cut through webs with 15x multiplier
  if (tool.kind === "sword" && def.tool === "sword") return 15;
  return def.tool === tool.kind ? tool.speed : 1;
}

/** Can the held item harvest a drop from this block? */
export function canHarvest(blockId: number, heldId: number): boolean {
  const def = BLOCKS[blockId];
  if (def.minTier <= 0) return true;

  const tool = toolInfo(heldId);
  return tool !== null && tool.kind === def.tool && tool.tier >= def.minTier;
}

/** Human-readable requirement such as "Wooden pickaxe", or null. */
export function requiredTool(blockId: number): string | null {
  const def = BLOCKS[blockId];
  if (def.minTier <= 0 || !def.tool) return null;
  const tier = TIER_NAMES[def.minTier] ?? "Better";
  return `${tier} ${def.tool}`;
}
